import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { QRCodeSVG } from 'qrcode.react'
import BigButton from 'components/buttons/bigButton'
import "./avis.scss"
export default function Avis() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Votre avis nous intéresse",
            icon : "picto vote - v2.svg",
            color : "bckOrange"
        })
    }, [])
    return (
        <div id="avis" className='page'>
            <ul>
                <li>
                    <img className="bulle" src="/picto_bulle_case.svg" alt="" />
                    <p><span>Questionnaire de satisfaction de l’accueil de la DRHF</span></p>
                </li>
                <div className='w100 flex center'>
                    <div className='cadre'>
                        URL du questionnaire accueil
                    </div>
                    <QRCodeSVG value="https://reactjs.org/" fgColor='#215fa5' bgColor='none' className='qrcode' size={150} />
                </div>
                <li>
                    <img className="bulle" src="/picto_bulle_case.svg" alt="" />
                    <p><span>Questionnaire de sortie du chu (démission, mutation)</span></p>
                </li>
                <div className='w100 flex center'>
                    <div className='cadre'>
                        URL du questionnaire sortie
                    </div>
                    <QRCodeSVG value="https://reactjs.org/" fgColor='#215fa5' bgColor='none' className='qrcode' size={150} />
                </div>
                <div className="w100 flex center">
                    <BigButton 
                        title={"Boîte à idées"}
                        icon={"picto_vote.svg"}
                        page={"/accueil/avis/boite_idee"} 
                        background={"bckDarkBlue"} 
                    />

                </div>
            </ul>

        </div>
    )
}
